// extracted by mini-css-extract-plugin
export default {"tableCards":"TableCards_tableCards__Nh9rG"};